export default function ReadabilityGauge({ score }) {
  if (!score || score.word_count === 0) {
    return (
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-center text-sm text-slate-400">
        Paste text and click Edit to see readability score
      </div>
    );
  }

  const ease = score.reading_ease || 0;
  const grade = score.flesch_kincaid_grade || 0;
  const clamped = Math.max(0, Math.min(100, ease));

  // Color based on readability
  let barColor = "bg-red-400";
  let textColor = "text-red-600";
  if (ease >= 60) { barColor = "bg-green-400"; textColor = "text-green-600"; }
  else if (ease >= 30) { barColor = "bg-amber-400"; textColor = "text-amber-600"; }

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-slate-700">Readability</h4>
        <span className={`text-xs font-bold ${textColor}`}>{score.reading_level}</span>
      </div>

      {/* Gauge bar */}
      <div className="relative h-3 bg-slate-200 rounded-full overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${clamped}%` }}
        />
      </div>

      <div className="grid grid-cols-3 gap-2 text-center">
        <div>
          <p className="text-lg font-bold text-slate-800">{score.word_count}</p>
          <p className="text-[10px] text-slate-500">Words</p>
        </div>
        <div>
          <p className="text-lg font-bold text-slate-800">{score.sentence_count}</p>
          <p className="text-[10px] text-slate-500">Sentences</p>
        </div>
        <div>
          <p className="text-lg font-bold text-slate-800">{score.avg_words_per_sentence || 0}</p>
          <p className="text-[10px] text-slate-500">Avg W/S</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 text-center">
        <div>
          <p className="text-sm font-semibold text-slate-700">{grade.toFixed(1)}</p>
          <p className="text-[10px] text-slate-500">Flesch-Kincaid Grade</p>
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-700">{ease.toFixed(0)}</p>
          <p className="text-[10px] text-slate-500">Reading Ease (0-100)</p>
        </div>
      </div>
    </div>
  );
}
